import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import reducers from "../reducers";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas/index";

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

// Add a persistConfig
const persistConfig = {
  key: "root",
  storage,
};

// Change your rootReducer to a persistedReducer using persistReducer
const persistedReducer = persistReducer(persistConfig, reducers);

function configureStore(preloadedState) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(persistedReducer, preloadedState, composeEnhancers(
    applyMiddleware(...middlewares)
  ));

  // Create a persistor based on the store
  const persistor = persistStore(store);

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept("../reducers/index", () => {
      const nextRootReducer = require("../reducers/index").default;
      store.replaceReducer(persistReducer(persistConfig, nextRootReducer));
    });
  }

  // return both store and persistor
  return { store, persistor };
}

const { store, persistor } = configureStore();

export { store, persistor };
